import React, { Component } from 'react'
import { connect } from 'react-redux'
import { render, findDOMNode } from 'react-dom';
import ReactMapboxGl, { GeoJSONLayer, Layer, Feature, ZoomControl, RotationControl, Cluster, Marker, Popup } from "react-mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css'
import { fetchLayer, fetchLayers, fetchLayerList, fetchMap, updateMap } from './actions';
import { LinearProgress, Divider } from '@material-ui/core';
import Popover from '@material-ui/core/Popover';
import LayerIcon from '@material-ui/icons/Layers';
import BoxIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import InfoIcon from '@material-ui/icons/Info';
import MailIcon from '@material-ui/icons/Mail';
import ExpandIcon from '@material-ui/icons/Fullscreen';
import CollapseIcon from '@material-ui/icons/FullscreenExit';
import CloseIcon from '@material-ui/icons/Close';
import moment from "moment"
import logo from './images/logo_schwarz_orange.png'
import { Paper, Card, CardContent, Popper, List, IconButton, ListItem, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import { ROOT_URL } from "../config";
import Typography from '@material-ui/core/Typography'
import { centroid, polygon, multiPolygon, bbox, lineString } from '@turf/turf';
import { Markdown } from 'react-showdown';
import { withNamespaces } from 'react-i18next'
import async from "async";

const MAPBOX_TOKEN = ""//process.env.MapboxAccessToken || 'pk.eyJ1IjoibW9yaXR6a25lY2h0IiwiYSI6ImNqYXZyNzdrMTExazcyd24waDI2a2hydWUifQ.5yuV5AFnTNMAZBXwI3MocA'; // eslint-disable-line

const Mapbox = ReactMapboxGl({
    //accessToken: MAPBOX_TOKEN
});

const styles = {
    clusterMarker: {
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: 'orange',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        border: '2px solid #56C498',
        cursor: 'pointer'
    },
    marker: {
        width: 15,
        height: 15,
        borderRadius: '50%',
        backgroundColor: 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px solid #C9C9C9'
    }
};

const symbolLayout = {

    'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
    'text-offset': [0, 0],
    'text-size': 15,
    'text-anchor': 'center',
    'icon-anchor': 'center',
    "icon-image": "{icon}",
    'icon-size': [
        'match',
        ['get', 'icon'],
        'warning_terror.png', 0.4,
        "warning_general.png", 0.4,
        "Hotspot_Pin-Kopie.png", 0.5,
        "Politischer_Extremismus_links.png", 0.5,
        'Politischer_Extremismus_Ausländer.png', 0.5,
        'Politischer_Extremismus_rechts.png', 0.5,
        'Moschee_Icon.png', 0.4,
        'graue_woelfe.jpg', 0.4,
        'apartment.png', 0.4,
        'usarmy.jpg', 0.4,
        'triangle-rape.png', 0.4,
        'triangle_assault_police.png', 0.4,

        0.3
    ],
    'icon-ignore-placement': false,
    'text-allow-overlap': true,
    'icon-allow-overlap': true

};
const symbolPaint = {
    'text-color': 'black',

};

GeoJSONLayer.prototype.initialize = function () {
    var map = this.context.map;
    map.addSource(this.id, this.source);
    this.createLayer('circle');
    this.createLayer('symbol');
    this.createLayer('line');
    this.createLayer('fill');
    this.createLayer('fill-extrusion');

};

const circleLayout = {
    visibility: 'visible',


};

const imageLayout = {
    visibility: 'visible',
    "id": "markers",
    "type": "symbol",
    "layout": {
        "icon-image": "https://riskcompass.eu/images/mapicons/{icon}",
    }
};

const circlePaint = {
    'circle-color': 'black',
    'circle-color': [
        'match',
        ['get', 'icon'],
        "blank_green.png", '#9CFF00',
        'warning_terror.png', 'black',
        "blank_black.png", 'black',
        "blank_pink.png", '#f442f1',
        "warning_general.png", 'yellow',
        "blank_red.png", '#ff0000',
        'medicine.png', '#000099',
        'caution.png', 'grey',
        'fire.png', '#ff9900',

     /* other */ 'purple'
    ],
    'circle-radius': 7,
    'circle-opacity': 1,
    'circle-stroke-width': 1,
    'circle-stroke-opacity': 0.75,
    'circle-stroke-color': 'black',



};

const polygonPaint = {

    'fill-color': [
        'match',
        ['get', 'riskLevel'],
        0, '#7d9cce',
        1, '#00ff00',
        2, '#ffff00',
        3, '#ffa500',
        4, '#ff6600',
        5, '#ff0000',
                            /* other */ '#7d9cce'
    ],
    'fill-opacity': 0.6,
    'fill-outline-color': '#464646'
};
/*
const polygonPaintCovid = {

    'fill-color': [
        'match',
        ['get', 'covid'],
        0, '#7d9cce',
        1, '#00ff00',
        2, '#ffff00',
        3, '#ffa500',
        4, '#ff6600',
        5, '#ff0000',
        6, '#d11515',
        7, '#8c0b0b',
                 '#7d9cce'
    ],
    'fill-opacity': 0.6,
    'fill-outline-color': '#464646'
};
*/

function polygonPaintCovid(riskPotential) {
    console.log('poly paint', riskPotential)

    return {

        'fill-color': [
            'match',
            ['get', riskPotential],
            0, '#7d9cce',
            1, '#00ff00',
            2, '#ffff00',
            3, '#ffa500',
            4, '#ff6600',
            5, '#ff0000',
            6, '#d11515',
            7, '#8c0b0b',
                                /* other */ '#7d9cce'
        ],
        'fill-opacity': 0.5,
        'fill-outline-color': '#464646'
    }
}

const polygonPaint2 = {
    'fill-color': '#ffff00',
    'fill-opacity': 0.0,
    'fill-outline-color': '#ffff00',
};

const multiPolygonPaint = {
    'fill-color': '#3bb2d0',
    'fill-opacity': 0.5
};

const layerPaint = {
    'heatmap-weight': {
        property: 'scalerank',
        type: 'exponential',
        stops: [
            [0, 0],
            [5, 2]
        ]
    },
    // Increase the heatmap color weight weight by zoom level
    // heatmap-ntensity is a multiplier on top of heatmap-weight
    'heatmap-intensity': {
        stops: [
            [0, 0],
            [5, 1.2]
        ]
    },
    // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
    // Begin color ramp at 0-stop with a 0-transparancy color
    // to create a blur-like effect.
    'heatmap-color': [
        'interpolate',
        ['linear'],
        ['heatmap-density'],
        0, 'rgba(33,102,172,0)',
        0.25, 'rgb(103,169,207)',
        0.5, 'rgb(209,229,240)',
        0.8, 'rgb(253,219,199)',
        1, 'rgb(239,138,98)',
        2, 'rgb(178,24,43)'
    ],
    // Adjust the heatmap radius by zoom level
    'heatmap-radius': {
        stops: [
            [0, 1],
            [5, 50]
        ]
    }
}

var PointPaint = {
    "id": "earthquakes-point",
    "type": "circle",
    "source": "earthquakes",
    "minzoom": 7,
    "paint": {
        // Size circle radius by earthquake magnitude and zoom level
        "circle-radius": [
            "interpolate",
            ["linear"],
            ["zoom"],
            7, [
                "interpolate",
                ["linear"],
                ["get", "mag"],
                1, 1,
                6, 4
            ],
            16, [
                "interpolate",
                ["linear"],
                ["get", "mag"],
                1, 5,
                6, 50
            ]
        ],
        // Color circle by earthquake magnitude
        "circle-color": [
            "interpolate",
            ["linear"],
            ["get", "mag"],
            1, "rgba(33,102,172,0)",
            2, "rgb(103,169,207)",
            3, "rgb(209,229,240)",
            4, "rgb(253,219,199)",
            5, "rgb(239,138,98)",
            6, "rgb(178,24,43)"
        ],
        "circle-stroke-color": "white",
        "circle-stroke-width": 1,
        // Transition from heatmap to circle layer by zoom level
        "circle-opacity": [
            "interpolate",
            ["linear"],
            ["zoom"],
            7, 0,
            8, 1
        ]
    }
}

// https://free.tilehosting.com/styles/basic/style.json?key=ALSU4XFuQjnG2jVilgsk
//var simple = 'https://free.tilehosting.com/styles/positron/style.json?key=ALSU4XFuQjnG2jVilgsk'  //http://tiles.vespertine.it/styles/positron/style.json'
var simple = 'https://free.tilehosting.com/data/v3.json?key=ALSU4XFuQjnG2jVilgsk'

/*{
    "version": 8,
    "sources": {
        "osm": {
            "type": "vector",
            "tiles": ["http://tiles.vespertine.it/data/v3/{z}/{x}/{y}.pbf"]
        }
    },
    "layers": [
        {
            "id": "background",
            "type": "background",
            "paint": {
                "background-color": "#41afa5"
            }
        }, {
            "id": "water",
            "type": "fill",
            "source": "osm",
            "source-layer": "water",
            "filter": ["==", "$type", "Polygon"],
            "paint": {
                "fill-color": "#3887be"
            }
        }
    ]
};*/

class Map extends Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            //bounds:[[-178.3539,-58.1107],[168.9131,69.6998]],
            layerMenuOpen: false,
            checked: [0],
            imagesLoaded: false,
            layers: [],
            style: this.getStyle("topo"),
            popup: null,
            labels: ["building"],
            zoomState: [0],
            pitchState: [0],
            bearingState: [0]
        }
        this.button = null
        this.map = null

    }

    handleToggle = value => () => {
        //  // console.log('handleToggle', value.id)
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value.id);
        // // console.log('currentIndex', currentIndex)
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value.id);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        this.setState({
            checked: newChecked,
        }, this.getLayers)
    };

    fetchLayer(ids) {
        const url = `${ROOT_URL}/Layers/featureCollection?ids=${encodeURIComponent(JSON.stringify(ids))}`

        return axios.get(url, {
            headers: { authorization: localStorage.getItem('token') }
        })
    }

    fetchGeojsonUrl(url) {
        url = url.replace("\/\/da", "\/da")
        return axios.get(url, {
            headers: {}
        })
    }

    fetchMap(id) {
        const url = `${ROOT_URL}/Maps/fullMap?id=${encodeURIComponent(id)}`

        return axios.get(url, {
            headers: { authorization: localStorage.getItem('token') }
        })
    }

    componentWillUnmount() {
        if (this.props.onRef) {
            this.props.onRef(undefined)
        }
    }


    componentDidMount() {
        if (this.props.onRef) {
            this.props.onRef(this)
        }


        //this.setState({ containerStyle: this.props.containerStyle })

        if (this.props.style) {
            this.setState({ style: this.getStyle(this.props.style) })
        }
        if (this.props.mapId) {
            this.setState({ mapId: this.props.mapId })


            this.fetchMap(this.props.mapId).then((res) => {

                console.log('fetchMap', res.data.title)
                var layers = res.data.layers

                const checked = layers.map(l => {
                    //console.log('l.type', l.type)
                    return l.id
                })

                //var f = layers[0].featureCollection.features
                ///// console.log('layers')

                var newState = { mapTitle: res.data.title, markdown: res.data.markdown, layers: layers, checked: checked, bounds: res.data.bounds }
                // console.log('newState', newState)
                this.setState(newState, () => {
                    // console.log('statezoom', this.state)
                })

            })
        }



        //// console.log('this.props.layerIds', this.props.layerIds)
        if (this.props.layerIds && this.props.layerIds.length) {

            //this.props.fetchMap("10")

            this.setState({ layerIds: this.props.layerIds })


            this.fetchLayer(this.props.layerIds).then((res) => {

                // // console.log('res', res.data)
                const layers = res.data
                /* layers = layers.map( layer => {
                     layer.styles = 
                 })*/

                this.setState({ layers: res.data })

            })



        }
        // this.props.fetchLayerList()

        //        this.props.fetchLayer("16")




    }

    clusterMarker = (coordinates, pointCount, getLeaves) => {

        return (
            <Marker key={coordinates + pointCount} coordinates={coordinates} style={styles.clusterMarker} onClick={this.clusterClick.bind(this, coordinates, pointCount, getLeaves)}>
                {pointCount}
            </Marker>
        )
    }

    fitBounds(featureCollection) {
        console.log('should fit bounds', featureCollection)
        var line = featureCollection.features.map(f => {

            return f.geometry.coordinates;
        })
        if (line && line.length > 1) {
            var box = bbox(lineString(line))
            // console.log('box', box)
            const bounds = [[box[0], box[1]], [box[2], box[3]]]
            // console.log('fitBounds', JSON.stringify(bounds))
            this.map.fitBounds(bounds, {
                padding: 20
            })
        }
        if (featureCollection.features.length == 1) {
            const f = featureCollection.features[0]
            this.map.flyTo({
                center: [f.geometry.coordinates[0], f.geometry.coordinates[1]],
                zoom: 7,
                speed: 2,
                curve: 0.75,
            })
            if (f.properties.geojsonUrl) {
                // console.log('geoUrl ', f.properties.geojsonUrl)
                this.fetchGeojsonUrl(f.properties.geojsonUrl).then(res => {
                    const geojson = res.data
                    this.setState({ geojson, geojsonUrl: f.properties.geojsonUrl })

                    if (f.properties.geojsonUrl.includes("riskcompass.eu")) {
                        this.map.addSource('earthquakes', {
                            "type": "geojson",
                            "data": f.properties.geojsonUrl
                        });

                        this.map.addLayer({
                            "id": "earthquakes-heat",
                            "type": "heatmap",
                            "source": "earthquakes",
                            "maxzoom": 9,
                            "paint": {
                                // Increase the heatmap weight based on frequency and property magnitude
                                "heatmap-weight": [
                                    "interpolate",
                                    ["linear"],
                                    ["get", "mag"],
                                    0, 0,
                                    6, 1
                                ],
                                // Increase the heatmap color weight weight by zoom level
                                // heatmap-intensity is a multiplier on top of heatmap-weight
                                "heatmap-intensity": [
                                    "interpolate",
                                    ["linear"],
                                    ["zoom"],
                                    0, 1,
                                    9, 3
                                ],
                                // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                                // Begin color ramp at 0-stop with a 0-transparancy color
                                // to create a blur-like effect.
                                "heatmap-color": [
                                    "interpolate",
                                    ["linear"],
                                    ["heatmap-density"],
                                    0, "rgba(33,102,172,0)",
                                    0.2, "rgb(103,169,207)",
                                    0.4, "rgb(209,229,240)",
                                    0.6, "rgb(253,219,199)",
                                    0.8, "rgb(239,138,98)",
                                    1, "rgb(178,24,43)"
                                ],
                                // Adjust the heatmap radius by zoom level
                                "heatmap-radius": [
                                    "interpolate",
                                    ["linear"],
                                    ["zoom"],
                                    0, 2,
                                    9, 20
                                ],
                                // Transition from heatmap to circle layer by zoom level
                                "heatmap-opacity": [
                                    "interpolate",
                                    ["linear"],
                                    ["zoom"],
                                    7, 1,
                                    9, 0
                                ],
                            }
                        });
                    }


                }).catch(err => {
                    // console.log('err', err)
                })
            }
        }
    }




    /*

    


              

                {layer && layer.features &&
                    <Layer
                        type="heatmap"
                        paint={layerPaint}
                    >
                        {
                            layer.features.map((el, index) => {
                               // console.log('el', el)
                                return <Feature
                                    key={index}
                                    coordinates={el.geometry.coordinates}
                                    properties={el.properties}
                                />
                            })
                        }
                    </Layer>
                }


                


    */

    /*
                  {

                layer &&
                <GeoJSONLayer
                    data={layer}
                    circleLayout={circleLayout}
                    circlePaint={circlePaint}
                   // circleOnClick={this.onClickCircle}
                    symbolLayout={symbolLayout}
                    symbolPaint={symbolPaint}
                />
                
                }
                <DrawControl />


                <Layer
                    type="heatmap"
                    paint={layerPaint}
                >
                    {
                        falls.features.map((el, index) => {
                           // console.log('el', el)
                            return <Feature
                                key={index}
                                coordinates={el.geometry.coordinates}
                                properties={el.properties}
                            />
                        })
                    }
                </Layer>

                 <Feature coordinates={[falls.features[0].polygonpoints]} />

    */

    onMapLoaded(map) {
        // console.log('mapLoaded')
        if (!map) {
            return
        }

        this.map = map

        var images = [
            "blank_green.png",
            'warning_terror.png',
            "blank_black.png",
            "blank_pink.png",
            "warning_general.png",
            "circle_brown_traffic_incident.png",
            "triangle_grey_warning_pollution.png",
            "triangle_blue_warning_health_outbreaks.png",
            "blank_red.png",
            'medicine.png',
            'caution.png',
            'fire.png',
            'Hotspot_Pin-Kopie.png',
            "Moschee_Icon.png",
            'graue_woelfe.jpg',
            'apartment.png',
            'usarmy.jpg',
            'Politischer_Extremismus_Ausländer.png',
            'Politischer_Extremismus_links.png',
            'Politischer_Extremismus_rechts.png',
            'triangle_rape.png',
            'triangle_assault_police.png'

        ]
        //  console.log('images', images)

        async.mapLimit(images, 20, (_image, cb) => {
            //cb(null, {})
            const url = window.location.origin + "/images/mapicons/" + _image
            console.log('image url', url)
            this.map.loadImage(url, (error, image) => {
                console.log('url', url, "loaded", error)
                /*if (error) {
                    console.log('error', error)
                    cb(null, error)
                    return
                }*/
                if (this.map && !error && image) {
                    this.map.addImage(_image, image)

                }
                cb({})
            })

        }, (err, result) => {
            console.log('images loaded')
            this.setState({ imagesLoaded: true })
        })

        /* map.on('click', (e) => {
             var features = map.queryRenderedFeatures(e.point)
            // console.log('features', features)
         })*/

        //console.log('featureCollection', this.props.featureCollection)
        //console.log('mapId', this.props.mapId)
        if (this.props.featureCollection && !this.props.mapId) {
            // console.log('should fit bounds #1')
            if (this.map && !this.props.heatmap) {
                this.fitBounds(this.props.featureCollection)
            }
            else if (this.map && this.props.heatmap) {
                console.log('add heatmap')
                this.map.addSource('earthquakes', {
                    "type": "geojson",
                    "data": this.props.featureCollection
                })
                this.map.addLayer({
                    "id": "earthquakes-heat",
                    "type": "heatmap",
                    "source": "earthquakes",
                    "maxzoom": 9,
                    "paint": {
                        // Increase the heatmap weight based on frequency and property magnitude
                        "heatmap-weight": [
                            "interpolate",
                            ["linear"],
                            ["get", "mag"],
                            0, 0,
                            6, 1
                        ],
                        // Increase the heatmap color weight weight by zoom level
                        // heatmap-intensity is a multiplier on top of heatmap-weight
                        "heatmap-intensity": [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            0, 1,
                            9, 3
                        ],
                        // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                        // Begin color ramp at 0-stop with a 0-transparancy color
                        // to create a blur-like effect.
                        "heatmap-color": [
                            "interpolate",
                            ["linear"],
                            ["heatmap-density"],
                            0, "rgba(33,102,172,0)",
                            0.2, "rgb(103,169,207)",
                            0.4, "rgb(209,229,240)",
                            0.6, "rgb(253,219,199)",
                            0.8, "rgb(239,138,98)",
                            1, "rgb(178,24,43)"
                        ],
                        // Adjust the heatmap radius by zoom level
                        "heatmap-radius": [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            0, 2,
                            9, 20
                        ],
                        // Transition from heatmap to circle layer by zoom level
                        "heatmap-opacity": [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            7, 1,
                            9, 0
                        ],
                    }
                });



            }



        }
        // console.log('should fit bounds #3', "mapId", this.props.mapId, "bounds", this.state.bounds)

        if (this.props.mapId && this.state.bounds) {
            // console.log('should fit bounds #2')
            this.map.fitBounds(this.state.bounds, {
                padding: 20
            })
        }
        map.resize()
        setTimeout(() => {
            // map.invalidateSize();
            map.resize()

        }, 100)


        if (false && this.state.labels) {

            //var labels = ["aerodrome_label", "building"]
            this.state.labels.forEach(label => {

                switch (label) {
                    case 'aerodrome_label':
                        map.addLayer({
                            "id": label,
                            "type": "symbol",
                            "source": {
                                type: 'vector',
                                bounds: [-120, -55.051129, 120, 55.051129],
                                url: 'https://maps.tilehosting.com/data/v3.json?key=ALSU4XFuQjnG2jVilgsk'
                            },
                            "source-layer": label,
                            "interactive": true,

                            "layout": {

                                "icon-allow-overlap": true,
                                "icon-image": "{marker-symbol}-11",
                                "text-field": "{name}",
                                "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
                                "text-size": 11,
                                "text-transform": "uppercase",
                                "text-letter-spacing": 0.05,
                                "text-offset": [0, 1.5]
                            },
                            "paint": {
                                "text-color": "#202",

                            },
                        });
                        break;
                    case "boundary":
                        map.addLayer({
                            "id": label,
                            "type": "line",
                            "source": {
                                type: 'vector',
                                url: 'https://maps.tilehosting.com/data/v3.json?key=ALSU4XFuQjnG2jVilgsk'
                            },

                            "source-layer": label,
                            "interactive": true,

                            "layout": {
                                "line-join": "round",
                                "line-cap": "round"
                            },
                            "paint": {
                                "line-color": "#234fff",
                                "line-width": 2
                            }
                        });

                        break;
                    default:
                        map.addLayer({
                            "id": label,
                            "type": "symbol",
                            "source": {
                                type: 'vector',
                                url: 'https://maps.tilehosting.com/data/v3.json?key=ALSU4XFuQjnG2jVilgsk'
                            },
                            "source-layer": label,
                            "interactive": true,

                            "layout": {

                                "icon-allow-overlap": true,
                                "icon-image": "{marker-symbol}-11",
                                "text-field": "{name}",
                                "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
                                "text-size": 11,
                                "text-transform": "uppercase",
                                "text-letter-spacing": 0.05,
                                "text-offset": [0, 1.5]
                            },
                            "paint": {
                                "text-color": "#202",

                            },
                        });
                        break;
                }


            })
        }

        //map.invalidateSize();
    }

    getCenter() {
        return this.map.getCenter()
    }

    handleClickButton = () => {
        this.setState({
            layerMenuOpen: true,
            anchorEl: findDOMNode(this.button),
        });
    };

    handleLegendButton = () => {
        this.setState({
            legendMenuOpen: true,
            anchorEl: findDOMNode(this.button),
        });
    };

    handleNewsletterButton = () => {
        this.setState({
            newsletterMenuOpen: true,
            anchorEl2: findDOMNode(this.button),
        });
    };

    getStyle(style) {
        var name = "topo"
        switch (style) {
            case 'basic':
                name = "basic"
                break;
            case 'light':
                name = "positron"
                break;
            case 'topo':
                name = "topo"
                break;
            case 'dark':
                name = "darkmatter"
                break;
            default:
                name = "topo"
                break;

        }
        // console.log('name', name)
        //topo/style.json?key=MnSoswF3TIIirAiE6mqv
        //   return "https://api.maptiler.com/maps/be8655a2-3c8f-4243-a818-14d7ebb83cd3/style.json?key=MnSoswF3TIIirAiE6mqv"
        return "https://api.maptiler.com/maps/fef74ea1-76e5-440f-b0d9-86450b327741/style.json?key=MnSoswF3TIIirAiE6mqv"
        //return "https://maps.tilehosting.com/c/131362e6-c138-4cc4-9e12-36d857d304bf/styles/" + name + "/style.json?key=MnSoswF3TIIirAiE6mqv";

    }

    reloadMap() {
        this.setState({ popup: null })
        this.fetchMap(this.props.mapId).then((res) => {

            // console.log('fetchMap', res.data)
            var layers = res.data.layers

            const checked = layers.map(l => {
                //// console.log('l.type', l.type)
                return l.id
            })
            var labels = null
            if (layers && layers.length > 0) {
                layers.forEach(layer => {
                    if (layer.type == "heatmap") {
                        this.map.addSource('earthquakes', {
                            "type": "geojson",
                            "data": layer.featureCollection
                        });
                        this.map.addLayer({
                            "id": "earthquakes-heat",
                            "type": "heatmap",
                            "source": "earthquakes",
                            "maxzoom": 9,
                            "paint": {
                                // Increase the heatmap weight based on frequency and property magnitude
                                "heatmap-weight": [
                                    "interpolate",
                                    ["linear"],
                                    ["get", "mag"],
                                    0, 0,
                                    6, 1
                                ],
                                // Increase the heatmap color weight weight by zoom level
                                // heatmap-intensity is a multiplier on top of heatmap-weight
                                "heatmap-intensity": [
                                    "interpolate",
                                    ["linear"],
                                    ["zoom"],
                                    0, 1,
                                    9, 3
                                ],
                                // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                                // Begin color ramp at 0-stop with a 0-transparancy color
                                // to create a blur-like effect.
                                "heatmap-color": [
                                    "interpolate",
                                    ["linear"],
                                    ["heatmap-density"],
                                    0, "rgba(33,102,172,0)",
                                    0.2, "rgb(103,169,207)",
                                    0.4, "rgb(209,229,240)",
                                    0.6, "rgb(253,219,199)",
                                    0.8, "rgb(239,138,98)",
                                    1, "rgb(178,24,43)"
                                ],
                                // Adjust the heatmap radius by zoom level
                                "heatmap-radius": [
                                    "interpolate",
                                    ["linear"],
                                    ["zoom"],
                                    0, 2,
                                    9, 20
                                ],
                                // Transition from heatmap to circle layer by zoom level
                                "heatmap-opacity": [
                                    "interpolate",
                                    ["linear"],
                                    ["zoom"],
                                    7, 1,
                                    9, 0
                                ],
                            }
                        });
                    }
                })
            }


            //  f.geometry.coordinates = f.geometry.coordinates[1]
            ///layers[0].featureCollection.features = [f]

            var newState = { mapTitle: res.data.title, markdown: res.data.markdown, mapId: this.props.mapId, layers: layers, checked: checked,/* zoomState: [res.data.zoom || 0], pitchState: [res.data.pitch || 0], bearingState: [res.data.bearing || 0], labels: res.data.labels,*/ bounds: res.data.bounds, style: res.data.style ? this.getStyle(res.data.style) : this.getStyle(this.props.style) }
            // console.log('newState#3', newState)
            this.setState(newState, () => {
                // console.log('statezoom#3', this.state)

            })



        })

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.riskPotentials && JSON.stringify(this.state.riskPotentials) != JSON.stringify(nextProps.riskPotentials) && nextProps.riskPotentials.length > 0) {
            this.setState({ riskPotential: nextProps.riskPotentials[0], riskPotentials: nextProps.riskPotentials })
        }

        if (this.props.layerList && this.props.layerList.length && nextProps.layerList.length > 0) // Check if it's a new user, you can also use some unique, like the ID
        {

            if (this.props.layerIds && this.props.layerIds.length) {
                //  // console.log('bla')
                this.props.layerIds.forEach((value) => {
                    //this.handleToggle({id:value})
                })
            } else {
                //  // console.log('layerIds not in props', this.props)

            }

        }
        if (nextProps.style) {
            // console.log('nextProps.style', nextProps.style)
            this.setState({ style: this.getStyle(nextProps.style) })
        }
        if (nextProps.layerIds && nextProps.layerIds.length && nextProps.layerIds != this.props.layerIds) {

            // console.log('nextProps.layersIds')

            this.setState({ layerIds: nextProps.layerIds })


            this.fetchLayer(nextProps.layerIds).then((res) => {

                //  // console.log('res', res.data)
                const layers = res.data
                /* layers = layers.map( layer => {
                     layer.styles = 
                 })*/

                this.setState({ layers: res.data })

            })



        }
        if (nextProps.featureCollection && !this.state.featureCollection) {
            // this.setState({featureCollection:nextProps.featureCollection})
        }
        if (nextProps.featureCollection && !nextProps.mapId) {
            console.log('fitbounds', nextProps)
            //console.log('nextProps.featureCollection', nextProps.featureCollection.length)
            if (this.map && !nextProps.heatmap) {
                this.fitBounds(nextProps.featureCollection)
            }
            else if (this.map && nextProps.heatmap) {
                console.log('add heatmap')
                /* this.map.addSource('earthquakes', {
                     "type": "geojson",
                     "data": nextProps.featureCollection
                 });*/
                this.map.addLayer({
                    "id": "earthquakes-heat",
                    "type": "heatmap",
                    "source": "earthquakes",
                    "maxzoom": 9,
                    "paint": {
                        // Increase the heatmap weight based on frequency and property magnitude
                        "heatmap-weight": [
                            "interpolate",
                            ["linear"],
                            ["get", "mag"],
                            0, 0,
                            6, 1
                        ],
                        // Increase the heatmp color weight weight by zoom level
                        // heatmap-intensity is a multiplier on top of heatmap-weight
                        "heatmap-intensity": [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            0, 1,
                            9, 3
                        ],
                        // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                        // Begin color ramp at 0-stop with a 0-transparancy color
                        // to create a blur-like effect.
                        "heatmap-color": [
                            "interpolate",
                            ["linear"],
                            ["heatmap-density"],
                            0, "rgba(33,102,172,0)",
                            0.2, "rgb(103,169,207)",
                            0.4, "rgb(209,229,240)",
                            0.6, "rgb(253,219,199)",
                            0.8, "rgb(239,138,98)",
                            1, "rgb(178,24,43)"
                        ],
                        // Adjust the heatmap radius by zoom level
                        "heatmap-radius": [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            0, 2,
                            9, 20
                        ],
                        // Transition from heatmap to circle layer by zoom level
                        "heatmap-opacity": [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            7, 1,
                            9, 0
                        ],
                    }
                });



            }
        }








        if (nextProps.mapId && nextProps.mapId != this.props.mapId) {
            // console.log('should fetchMap in receive')
            //this.props.fetchMap("10")
            if (this.map && this.map.getLayer && this.map.getLayer("earthquakes-heat")) {
                this.map.removeLayer("earthquakes-heat");
            }

            if (this.map && this.map.getSource('earthquakes')) {
                this.map.removeSource('earthquakes');
            }

            this.setState({ mapId: nextProps.mapId })


            this.fetchMap(nextProps.mapId).then((res) => {

                // console.log('fetchMap', res.data)
                var layers = res.data.layers

                const checked = layers.map(l => {
                    //// console.log('l.type', l.type)
                    return l.id
                })
                var labels = null
                if (layers && layers.length > 0) {
                    layers.forEach(layer => {
                        if (layer.type == "heatmap") {
                            this.map.addSource('earthquakes', {
                                "type": "geojson",
                                "data": layer.featureCollection
                            });
                            this.map.addLayer({
                                "id": "earthquakes-heat",
                                "type": "heatmap",
                                "source": "earthquakes",
                                "maxzoom": 9,
                                "paint": {
                                    // Increase the heatmap weight based on frequency and property magnitude
                                    "heatmap-weight": [
                                        "interpolate",
                                        ["linear"],
                                        ["get", "mag"],
                                        0, 0,
                                        6, 1
                                    ],
                                    // Increase the heatmap color weight weight by zoom level
                                    // heatmap-intensity is a multiplier on top of heatmap-weight
                                    "heatmap-intensity": [
                                        "interpolate",
                                        ["linear"],
                                        ["zoom"],
                                        0, 1,
                                        9, 3
                                    ],
                                    // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                                    // Begin color ramp at 0-stop with a 0-transparancy color
                                    // to create a blur-like effect.
                                    "heatmap-color": [
                                        "interpolate",
                                        ["linear"],
                                        ["heatmap-density"],
                                        0, "rgba(33,102,172,0)",
                                        0.2, "rgb(103,169,207)",
                                        0.4, "rgb(209,229,240)",
                                        0.6, "rgb(253,219,199)",
                                        0.8, "rgb(239,138,98)",
                                        1, "rgb(178,24,43)"
                                    ],
                                    // Adjust the heatmap radius by zoom level
                                    "heatmap-radius": [
                                        "interpolate",
                                        ["linear"],
                                        ["zoom"],
                                        0, 2,
                                        9, 20
                                    ],
                                    // Transition from heatmap to circle layer by zoom level
                                    "heatmap-opacity": [
                                        "interpolate",
                                        ["linear"],
                                        ["zoom"],
                                        7, 1,
                                        9, 0
                                    ],
                                }
                            });
                        }
                    })
                }


                //  f.geometry.coordinates = f.geometry.coordinates[1]
                ///layers[0].featureCollection.features = [f]

                var newState = { mapTitle: res.data.title, markdown: res.data.markdown, mapId: nextProps.mapId, layers: layers, checked: checked,/* zoomState: [res.data.zoom || 0], pitchState: [res.data.pitch || 0], bearingState: [res.data.bearing || 0], labels: res.data.labels,*/ bounds: res.data.bounds, style: res.data.style ? this.getStyle(res.data.style) : this.getStyle(this.props.style) }
                // console.log('newState#3', newState)
                this.setState(newState, () => {
                    // console.log('statezoom#3', this.state)

                })



            })



        }
    }



    handleClose = () => {
        this.setState({
            layerMenuOpen: false,
            legendMenuOpen: false,

        });
    };
    handleNewsletterClose = () => {
        this.setState({
            newsletterMenuOpen: false,


        });
    };

    renderLayers() {

        const { mapStyle, layerMenuOpen, anchorEl, popup } = this.state
        const { layer, loading, layerList } = this.props

        return (
            <div>

            </div>
        )
    }
    /*
        loadChapter(dossierId) {
            console.log('dossierId', dossierId)
            this.props.fetchDossierChapters(dossierId).then(chapter => {
                // console.log('chapter', chapter)
                this.setState({ chapter: this.props.chapter })
            }).catch(err => {
                console.log('err', err)
            })
        }*/

    renderPopup() {
        const { popup } = this.state
        var { lang, t, admin } = this.props
        var coordinates = []
        var json = null
        //  console.log('renderPopup admin', admin)
        lang = "de"
        if (popup && popup.geometry) {
            //console.log('centerOfMass(popup)', centerOfMass(popup))
            //coordinates = (popup.geometry.type == 'Polygon' || popup.geometry.type == 'MultiPolygon') ? centroid(feature(popup)) : popup.geometry.coordinates
            coordinates = []
            if (popup.geometry.type == 'Polygon') {
                coordinates = centroid(polygon(popup.geometry.coordinates)).geometry.coordinates
            } else if (popup.geometry.type == 'MultiPolygon') {
                coordinates = centroid(multiPolygon(popup.geometry.coordinates)).geometry.coordinates
            } else {
                coordinates = popup.geometry.coordinates
            }
            // console.log('coordinates', coordinates)
            //// console.log('item', popup.properties)
            console.log('popup.properties', popup.properties)
            console.log(' typeof popup.properties.title', popup.properties.title && (typeof popup.properties.title == "string") || popup.properties.name)
        }


        //console.log('coordinates', coordinates)
        return (

            popup && (
                <Popup style={{ padding: 'none' }} offset={[10, 10]} coordinates={coordinates} onClick={() => {
                    if (!admin) {
                        this.setState({ popup: null })
                    }

                }}>
                    <div style={{
                        background: 'white',
                        color: 'black',

                        //padding: '5px',
                        minWidth: '200px',
                        maxWidth: '450px',
                        //borderRadius: '2px'
                    }} >
                        <div style={{ padding: 5 }}>
                            <CloseIcon style={{ float: 'right', marginTop: 0, marginRight: 0 }} onClick={() => {

                                this.setState({ popup: null })

                            }} />
                            {(popup.properties.title && typeof popup.properties.title == "string") &&
                                <Typography variant="heading" gutterBottom>
                                    <b>{popup.properties.title}</b>
                                </Typography>
                            }
                            {(!popup.properties.title && typeof popup.properties.name == "string") &&
                                <Typography variant="subheading" gutterBottom>
                                    <b> {popup.properties.name}</b>
                                </Typography>
                            }

                            {popup.properties.title && typeof popup.properties.title == "object" &&
                                <Typography variant="subheading" gutterBottom>
                                    <b style={{ fontSize: 14 }}>{popup.properties.title[lang]}</b>
                                </Typography>
                            }

                            { false && popup.properties &&
                                <Typography variant="caption" gutterBottom>
                                    {this.json({
                                        Moschee: popup.properties.Moschee,
                                        name: popup.properties.name,
                                        Straße: popup.properties.Straße,
                                        street: popup.properties.street,
                                        Ort: popup.properties.Ort,
                                        city: popup.properties.city,

                                    })}
                                </Typography>
                            }
  {(popup.properties.verband || popup.properties.name2 || popup.properties.strasse)  &&
                                <Typography variant="caption" gutterBottom>

                                    <div>
                                        <div>{popup.properties.name2}</div>

                                        <br />
                                        <div>{popup.properties.plz} {popup.properties.city}</div>
                                        <div>{popup.properties.strasse}</div>
                                        <div>{popup.properties.tel}</div>
                                        <div>{popup.properties.verband}</div>




                                    </div>





                                </Typography>
                            }
                            {popup.properties.markdown && !popup.properties.dossier &&
                                <div style={{
                                    height: 100, maxHeight: 100, overflowY: 'scroll',
                                    WebkitOverflowScrolling: 'touch'
                                }}>

                                    <Markdown style={{ maxWidth: '400px' }} markup={popup.properties.markdown} tables={true} />
                                </div>
                            }

                            {this.props.riskPotential == "covid" &&
                                <div>
                                    <div style={{ marginTop: 15 }}>
                                        <b>{t("dossier.Covid")}</b> {popup.properties.covid}
                                    </div>
                                    {popup.properties.covidInfo &&
                                        <div>
                                            <div style={{ marginTop: 0, padding: 0, lineHeight: '13px' }}>
                                                {t("map.Bestätigt")} {popup.properties.covidInfo.confirmed}
                                            </div>
                                            <div style={{ marginTop: 0, padding: 0, lineHeight: '13px' }}>
                                                {t("map.Tote")} {popup.properties.covidInfo.deaths}
                                            </div>
                                            <div style={{ marginTop: 0, padding: 0, lineHeight: '13px' }}>
                                                {t("map.Geheilt")} {popup.properties.covidInfo.recoverd}
                                            </div>
                                            <div style={{ marginTop: 0, padding: 0, lineHeight: '13px' }}>
                                                {t("map.Update")} {moment(popup.properties.covidInfo.last_update).format("DD.MM.YYYY, HH:mm ")} Uhr
                                            </div>
                                        </div>
                                    }
                                    {this.state.chapter &&
                                        <div style={{ marginTop: 10 }}>
                                            <div style={{
                                                height: 150, maxHeight: 150, overflowY: 'scroll',
                                                WebkitOverflowScrolling: 'touch'
                                            }}>
                                                <div style={{ fontSize: 14 }}><b>{t("dossier.situationReport")}</b></div>
                                                <Markdown markup={this.state.chapter.markdown[lang]}>
                                                </Markdown>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            {popup.properties.incidentScene &&
                                <div>

                                    <b>{t("map.Ereignisort")}</b> {popup.properties.incidentScene}

                                </div>
                            }
                            {popup.properties.postName &&
                                <a style={{ float: 'right' }} href={"https://riskcompass.eu/article/" + popup.properties.postName}>{t("map.ZumArtikel")}</a>
                            }

                        </div>
                    </div>
                </Popup>
            )

        )
    }

    renderLegend() {

        const { mapStyle, legendMenuOpen, anchorEl, checked, layers } = this.state
        const { layer, loading, layerList } = this.props

        return (
            <div>
                <Button variant="contained" aria-label="Layers" style={{
                    backgroundColor: 'rgb(249, 249, 249)', opacity: 0.95, zIndex: 1000, top: 110, left: 10, minWidth: 28, minHeight: 28,
                    padding: 0
                }} onClick={this.handleLegendButton}
                    ref={node => {
                        this.button = node;
                    }}>
                    <InfoIcon style={{ fontSize: 15 }} />
                </Button>

                <Popover
                    open={legendMenuOpen}
                    anchorEl={anchorEl}
                    anchorReference='anchorEl'
                    anchorPosition={{ top: 60, left: 20 }}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}

                >
                    <div style={{ width: 300 }}>
                        <table>
                            <tbody>

                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/warning_general.png'} height="30" width="30" />
                                    </td>
                                    <td> Reisewarnung, Wetterwarnung</td>
                                </tr>
                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/warning_terror.png'} height="30" width="30" />
                                    </td>
                                    <td> Terrorwarnung</td>
                                </tr>
                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/triangle_grey_warning_pollution.png'} height="30" width="30" />
                                    </td>
                                    <td> Warnung vor Umweltverschmutzung</td>
                                </tr>
                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/triangle_blue_warning_health_outbreaks.png'} height="30" width="30" />
                                    </td>
                                    <td> Gesundheitswarnung</td>
                                </tr>
                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/caution.png'} height="30" width="30" />
                                    </td>
                                    <td >
                                        Verkehrsrisiken.
                                    </td>
                                </tr>



                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/triangle-rape.png'} height="30" width="30" />
                                    </td>
                                    <td >
                                        Sexualdelikt, Vergewaltigung.
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/triangle_assault_police.png'} height="30" width="30" />
                                    </td>
                                    <td >
                                        Übergriffe auf Polizei und Rettungskräfte
                                    </td>
                                </tr>



                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/blank_black.png'} height="30" width="30" />
                                    </td>
                                    <td> Bürgerkriegsereignisse, Terrorismus, Terroranschläge, Sabotageaktionen.</td>
                                </tr>
                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/blank_red.png'} height="30" width="30" />
                                    </td>
                                    <td>
                                        Gewaltkriminalität, Körperverletzung, Totschlag, Raub, Mord.
                                    </td>
                                </tr>


                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/fire.png'} height="30" width="30" />
                                    </td>
                                    <td>
                                        Sachbeschädigung, Brand und Brandstiftung, Vandalismus.
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/blank_pink.png'} height="30" width="30" />
                                    </td>
                                    <td>
                                        Soziale Unruhen, Aufruhr, Demonstrationen, Streik.
                                    </td>
                                </tr>



                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/blank_green.png'} height="30" width="30" />
                                    </td>
                                    <td>
                                        Naturgefahren, Stürme, Erdbeben, Vulkanismus, Überschwemmungen, Dürre, Extremwetter.
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/medicine.png'} height="30" width="30" />
                                    </td>
                                    <td>
                                        Gesundheitsrisiken, Seuchenausbrüche.
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <img src={'/images/mapicons/Hotspot_Pin-Kopie.png'} height="30" width="30" />
                                    </td>
                                    <td>
                                        »Meidegebiet«, sozialer Brennpunkt, »kriminalitätsbelasteter Ort« oder Naturgefahren
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </Popover>
            </div>
        )
    }

    renderNewsletter() {

        const { mapStyle, newsletterMenuOpen, anchorEl2, checked, layers } = this.state
        //<MailIcon style={{ fontSize: 30 }} />
        return (
            <div>
                <Button variant="contained" aria-label="Newsletter" style={{
                    backgroundColor: 'rgb(249, 249, 249)',
                    opacity: 0.95, zIndex: 1000,

                    marginTop: 10,
                    float: 'right',
                    backgroundColor: '#FFFFFFFF',
                    //  right: 20,
                    marginRight: 10,
                    maxHeight: 56,
                    //minWidth: 155, minHeight: 55,
                    //padding: 0
                }} color="secondary" onClick={this.handleNewsletterButton}
                    ref={node => {
                        this.button = node;
                    }}>
                    Newsletter
                </Button>

                <Popover
                    open={newsletterMenuOpen}
                    anchorEl={anchorEl2}
                    anchorReference='anchorEl2'
                    anchorPosition={{ top: 60, left: 40 }}
                    onClose={this.handleNewsletterClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}

                >
                    <div style={{ width: 300 }}>
                        <Card>
                            <CardContent>
                                <div style={{ textAlign: 'left', fontSize: 14 }}>
                                    <div style={{ marginTop: 8, marginLeft: 8, textAlign: 'left', fontSize: 14 }}>
                                        Weitere exklusive News und Hintergrundberichte jede Woche aktuell im kostenlosen »RiskCompass Intelligence-Newsletter«.
                                    </div>

                                    <Button variant="contained" style={{ marginTop: 10 }} color="secondary">
                                        Hier abonnieren
                                    </Button>

                                </div>
                            </CardContent>
                        </Card>
                    </div>

                </Popover>
            </div>
        )
    }

    editLayer(item) {
        console.log('editLayer', item)
        this.props.goToRoute()
    }

    renderSaveBounds() {
        return (
            <Button variant="contained" aria-label="Layers" style={{
                backgroundColor: 'rgb(249, 249, 249)', opacity: 0.95, zIndex: 1000, top: 100, left: 10, minWidth: 28, minHeight: 28,
                padding: 0
            }} onClick={this.saveBounds.bind(this)}
                ref={node => {
                    // this.button = node;
                }}>
                <BoxIcon style={{ fontSize: 15 }} />
            </Button>
        )
    }


    renderLayerMenu() {

        const { mapStyle, layerMenuOpen, anchorEl, checked, layers } = this.state
        const { layer, loading, layerList, admin, editor, map, mapId } = this.props
        // console.log('map', map, mapId)
        return (
            <div>
                <Button variant="contained" aria-label="Layers" style={{
                    backgroundColor: 'rgb(249, 249, 249)', opacity: 0.95, zIndex: 1000, top: 100, left: 10, minWidth: 28, minHeight: 28,
                    padding: 0
                }} onClick={this.handleClickButton}
                    ref={node => {
                        this.button = node;
                    }}>
                    <LayerIcon style={{ fontSize: 15 }} />
                </Button>

                <Popover
                    open={layerMenuOpen}
                    anchorEl={anchorEl}
                    anchorReference='anchorEl'
                    anchorPosition={{ top: 60, left: 20 }}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <List style={{ width: 300 }}>
                        {layers.length > 0 && layers.map(value => (
                            <ListItem
                                key={value.id}
                                dense
                                button
                                onClick={this.handleToggle(value)}

                            >
                                <Checkbox
                                    checked={this.state.checked.indexOf(value.id) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                />
                                <ListItemText primary={value.title} />


                            </ListItem>
                        ))}

                    </List>

                </Popover>
            </div>
        )
    }

    onZoomEnd(value) {
        if (this.props.onZoomEnd) {
            this.props.onZoomEnd(value)
        }
    }

    onPitchEnd(value) {
        if (this.props.onPitchEnd) {
            this.props.onPitchEnd(value)
        }
    }

    onRotateEnd(value) {
        if (this.props.onRotateEnd) {
            this.props.onRotateEnd(value)
        }
    }

    onMoveEnd(value) {
        if (this.props.onMoveEnd && this.map) {
            var bounds = this.map.getBounds()
            //this.props.onMoveEnd(bounds)
        }
    }

    saveBounds() {
        if (this.map && this.props.saveBounds) {
            var bounds = this.map.getBounds()
            var bbox = [[bounds._sw.lng, bounds._sw.lat], [bounds._ne.lng, bounds._ne.lat]]
            console.log('bbox', bbox)
            console.log('mapId', this.state.mapId)
            this.props.updateMap({ id: this.state.mapId, bounds: bbox }).then(res => {
                console.log('res', res)
                this.fetchMap(this.props.mapId).then((res) => {
                    console.log('map fetched')
                    //// console.log('fetchMap', res.data)
                    var layers = res.data.layers

                    const checked = layers.map(l => {
                        //console.log('l.type', l.type)
                        return l.id
                    })

                    //var f = layers[0].featureCollection.features
                    ///// console.log('layers')

                    var newState = { layers: layers, checked: checked, bounds: res.data.bounds }
                    // console.log('newState', newState)
                    this.setState(newState, () => {
                        // console.log('statezoom', this.state)
                    })

                })
            }).catch(err => {
                console.log('err', err)
            })
            // this.props.
        }
    }

    /*
 
     <Layer type="fill" paint={polygonPaint}>
                        <Feature coordinates={[falls.features[0].polygonpoints]} />
                    </Layer>
 
 
                    <Layer type="fill" paint={polygonPaint2}>
                        <Feature coordinates={[falls.features[1].polygonpoints]} />
 
                    </Layer>
 
    */

    json(data) {
        return <div><pre>{JSON.stringify(data, null, 2)}</pre></div>;
    }



    clusterClick(coordinates, pointCount, getLeaves) {
        //console.log('feature of cluster: ' , feature)
        // this.setState({
        //     popup: feature
        // });
        // feature.getLeaves();
        //console.log('coordinates', coordinates)
        //console.log('cluster coordinates: ', getLeaves());

        var features = getLeaves().map(leave => { return leave.props["data-feature"] })
        //console.log('features')
        /* this.setState({
             popup: {geometry: coordinates, features:features}
         });*/
        /*
                this.map.flyTo({
                    center: coordinates,
                    zoom:5
                });*/
    };

    markerClick(feature) {
        // console.log('feature', feature)
        if (this.props.onSelected && feature) {
            this.props.onSelected(feature.properties)
        }
        if (feature && feature.properties.dossier) {
            //  this.loadChapter(feature.properties.dossier)

        }


        this.setState({
            popup: feature
        });
    };

    selectMarker(id) {
        // console.log('selectMarker', feature)
        if (this.props.featureCollection && this.props.featureCollection.features) {
            const feature = this.props.featureCollection.features.filter(f => {
                return f.properties.id == id
            })
            // console.log('selectMarker', feature)
            if (feature.length > 0) {
                const f = feature[0]
                this.setState({
                    popup: f
                });
                this.map.flyTo({
                    center: [f.geometry.coordinates[0], f.geometry.coordinates[1]],
                    zoom: 5,
                    speed: 1,
                    curve: 0.5,
                })
            }
        }
    }

    geoJSONLayerClick(e) {
        //// console.log('geoJSONLayerClick', e)
        var features = this.map.queryRenderedFeatures(e.point);
        var feature = features[0]
        if (this.props.onSelected && feature) {
            this.props.onSelected(feature.properties)
        }

        this.setState({
            popup: feature
        });

    }

    renderMarker(feature, index) {

        const { properties } = feature
        //console.log('renderMarker', feature)
        var icon = false
        if (properties.icon) {
            // icon = getIcon(properties.icon)
            icon = '/images/mapicons/' + properties.icon;
        }
        //console.log('index', index)
        //// console.log('icon', icon)



        return <Marker

            key={feature.properties.title}
            style={styles.marker}
            onClick={this.markerClick.bind(this, feature)}
            coordinates={feature.geometry.coordinates}
            data-feature={feature}
        >
            {icon &&
                <img src={icon} />
            }


        </Marker>
    }



    /*
<GeoJSONLayer
                            circleLayout={circleLayout}
                            circlePaint={circlePaint}
                            circleOnClick={this.geoJSONLayerClick.bind(this)}
 
                            data={featureCollection} />
 
    */

    /*
  <GeoJSONLayer
                            circleLayout={circleLayout}
                            circlePaint={circlePaint}
                            symbolLayout={"none"}
                            //circleOnClick={this.geoJSONLayerClick.bind(this)}
                            circleOnClick={this.geoJSONLayerClick.bind(this)}
                            data={geojson} />
 
 
 
 
 
 
    */

    handleExpandButton() {
        if (this.props.onExpand) {
            this.props.onExpand()
        }
    }

    resize() {
        if (this.map) {
            // console.log('triggered resize')
            this.map.resize()
        }
    }

    onTitleClick(event) {
        var { titleEl } = this.state
        titleEl = titleEl ? null : event.currentTarget
        this.setState({ titleEl })
    }

    changeRiskpotential(event) {
        console.log('riskPotential', event.target.value)
        this.setState({ riskPotential: event.target.value })
    }
    render() {

        const { imagesLoaded, geojson, geojsonUrl, titleEl, mapStyle, layerMenuOpen, anchorEl, layers, drawControl, checked, style, zoomState, bounds, mapTitle, markdown } = this.state
        const { layer, loading, layerList, zoom, bearing, pitch, containerStyle, featureCollection, onExpand, expanded, heatmap, admin, title } = this.props
        const lang = "de"
        console.log('riskPotential', this.state.riskPotential)
        return (
            <div style={{ width: '100%', height: '100%' }}>{loading &&
                <LinearProgress style={{ marginTop: '9px' }} />
            }
                <Mapbox
                    style={style}
                    renderWorldCopies={false}
                    onZoomEnd={this.onZoomEnd.bind(this)}
                    onPitchEnd={this.onPitchEnd.bind(this)}
                    onRotateEnd={this.onRotateEnd.bind(this)}
                    onMoveEnd={this.onMoveEnd.bind(this)}
                    onStyleLoad={this.onMapLoaded.bind(this)}
                    containerStyle={containerStyle || { height: '100%', width: '100%' }}
                    // preserveDrawingBuffer={false}
                    onMapLoaded={this.onMapLoaded.bind(this)}
                    //center={this.props.center}
                    preserveDrawingBuffer={true}
                    fitBounds={this.state.bounds}
                    zoom={zoomState || [0]}
                //bearing={bearing || [0]}
                //pitch={pitch || [0]}>
                >
                    {layers.length > 0 &&
                        this.renderLayerMenu()
                    }
                    {admin && this.props.saveBounds &&
                        this.renderSaveBounds()
                    }
                    {admin && layers.length == 0 &&
                        this.renderLayerMenu()
                    }
                    {
                        this.renderLegend()
                    }
                    {
                        // this.renderNewsletter()
                    }

                    {imagesLoaded && featureCollection && !heatmap && featureCollection.features && featureCollection.features.length > 0 &&



                        <GeoJSONLayer
                            data={featureCollection}
                            layerOptions={{ minZoom: 0 }}
                            symbolLayout={symbolLayout}
                            symbolPaint={symbolPaint}
                            // layerOptions={{ id: "news" }}
                            fillPaint={polygonPaint2}
                            symbolOnClick={this.geoJSONLayerClick.bind(this)}
                        />

                    }
                    {imagesLoaded && featureCollection && heatmap && featureCollection.features && featureCollection.features.length > 0 &&

                        //   <Cluster maxZoom={4} ClusterMarkerFactory={this.clusterMarker} zoomOnClick={true} zoomOnClickPadding={50}>
                        //
                        //                           {featureCollection && featureCollection.features && featureCollection.features.map((feature, index) => (
                        ///                             
                        //                          this.renderMarker(feature, index)
                        //                    ))}
                        //              </Cluster>

                        <GeoJSONLayer
                            key={"heatmap"}
                            data={featureCollection}
                            symbolLayout={"none"}
                            before={"earthquakes-heat"}
                            circleLayout={circleLayout}
                            circlePaint={circlePaint}
                            //   circlePaint={circlePaint}
                            fillPaint={polygonPaint2}
                            circleOnClick={this.geoJSONLayerClick.bind(this)} />

                    }

                    {geojson && geojsonUrl &&

                        <GeoJSONLayer
                            data={geojson}
                            symbolLayout={"none"}
                            circleLayout={geojsonUrl.includes("riskcompass.eu") || geojsonUrl.includes("https") ? circleLayout : "none"}
                            circlePaint={circlePaint}
                            //  circlePaint={circlePaint}
                            fillPaint={polygonPaint2}
                            circleOnClick={this.geoJSONLayerClick.bind(this)}
                        // circleOnClick={this.onClickCircle}

                        />


                    }


                    {layers.length > 0 &&
                        layers.filter(l => {
                            return checked.indexOf(l.id) != -1
                        }).map((layer, index) => {
                            //// console.log('layer.type', layer.type)
                            if (layer.type == "riskmap" || layer.type == "country" || layer.type == "states") {
                                //// console.log('should render layer')
                                return (
                                    <Layer before={featureCollection ? "news" : null} key={index} type="fill" paint={this.state.riskPotential ? polygonPaintCovid(this.state.riskPotential) : polygonPaint} >



                                        {layer.featureCollection && layer.featureCollection.features && layer.featureCollection.features.map((feature, index) => {
                                            //if (feature.properties.name == "Brandenburg") {
                                            //     console.log('feature', feature)
                                            // console.log('feature',feature.geometry.coordinates)
                                            return <Feature key={index} properties={feature.properties} coordinates={feature.geometry.coordinates} onClick={this.markerClick.bind(this, feature)} />

                                            // }

                                            //  return   <Feature key={index} properties={feature.properties} coordinates={feature.geometry.coordinates} onClick={this.markerClick.bind(this, feature)} />

                                        }

                                        ).filter(item => {
                                            return item != null
                                        })}
                                    </Layer>




                                )
                            } else if ((layer.type == "static" || layer.type == "featureCollection") && layer.featureCollection && layer.featureCollection.features) {
                                return (
                                    /*  <Cluster key={index} ClusterMarkerFactory={this.clusterMarker} zoomOnClick={true} zoomOnClickPadding={50}>

                    {layer.featureCollection && layer.featureCollection.features && layer.featureCollection.features.map((feature, index) => (
                        this.renderMarker(feature, index)
                    ))}
                </Cluster>*/

                                    <GeoJSONLayer
                                        data={layer.featureCollection}
                                        layerOptions={{ minZoom: 0, maxZoom: 20 }}
                                        symbolLayout={symbolLayout}
                                        symbolPaint={symbolPaint}


                                        fillPaint={polygonPaint2}
                                        symbolOnClick={this.geoJSONLayerClick.bind(this)}
                                    />
                                )
                            } else if (layer.type == "heatmap") {
                                return (
                                    <GeoJSONLayer
                                        key={index}
                                        data={layer.featureCollection}
                                        symbolLayout={"none"}
                                        before={"earthquakes-heat"}
                                        circleLayout={circleLayout}
                                        circlePaint={circlePaint}

                                        fillPaint={polygonPaint2}
                                        circleOnClick={this.geoJSONLayerClick.bind(this)}
                                    // circleOnClick={this.onClickCircle}

                                    />
                                )
                            }





                        }



                        )
                    }
                    {this.renderPopup()}



                    < ZoomControl
                        position="top-left" />
                    <RotationControl
                        position="top-left" />

                    {mapTitle &&
                        <div style={{

                            opacity: 0.95, zIndex: 1000,
                            marginTop: -40,
                            float: 'right',
                            backgroundColor: '#FFFFFFFF',
                            //  right: 20,
                            marginRight: 10,
                            maxHeight: 56,
                            padding: 0,

                        }}>
                            <Button
                                style={{
                                    backgroundColor: 'rgb(249, 249, 249)',
                                }}
                                variant="contained" aria-label="Info"

                                onClick={this.onTitleClick.bind(this)}
                            >

                                {mapTitle}

                            </Button>
                            {markdown &&
                                <Popper placement={'bottom-end'} style={{ marginTop: 10, marginRight: 0 }} id={"titlePopper"} open={titleEl} anchorEl={titleEl}>
                                    <CloseIcon style={{ float: 'right', marginTop: 5, marginRight: 5 }} onClick={this.onTitleClick.bind(this, null)} />
                                    <Paper style={{
                                        maxWidth: 430, padding: 20, paddingTop: 5, maxHeight: 250, height: 250,
                                    }}>
                                        <div style={{
                                            overflowY: 'scroll', maxHeight: 250, height: 250,
                                            WebkitOverflowScrolling: 'touch'
                                        }}>
                                            <Markdown markup={lang == "de" ? markdown.de : markdown.en}>
                                            </Markdown>
                                        </div>
                                    </Paper>
                                </Popper>
                            }
                        </div>
                    }
                    {onExpand &&
                        <Button variant="contained" aria-label="Fullscreen" style={{
                            backgroundColor: 'rgb(249, 249, 249)', opacity: 0.95, zIndex: 1000, top: -20, float: 'right', right: 10,
                            minWidth: 28, minHeight: 28,
                            padding: 0
                        }} onClick={this.handleExpandButton.bind(this)}
                            ref={node => {
                                this.expandButton = node;
                            }}>
                            {expanded ? <CollapseIcon style={{ fontSize: 17 }} /> : <ExpandIcon style={{ fontSize: 17 }} />}
                        </Button>
                    }
                    {true &&

                        <div className="mapboxgl-ctrl-bottom-left">
                            <div style={{
                                // onClick={}
                                // opacity: 0.95, 
                                pointerEvents: 'auto',
                                //  zIndex: "1000 !important",
                                marginBottom: 10,
                                float: 'left',
                                //backgroundColor: '#FFFFFFFF',
                                //  right: 20,
                                marginLeft: 10,
                                maxHeight: 56,
                                padding: 0,

                            }}>


                            </div>
                        </div>

                    }


                </Mapbox>



            </div >
        );
    }
}

function mapStateToProps(state) {
    /* let filtered = _.isEmpty(state.posts.postsGridData.gridFilters) ? [] : state.posts.postsGridData.gridFilters;
     let sorted = _.isEmpty(state.posts.postsGridData.gridSortCriteria) ? [] : state.posts.postsGridData.gridSortCriteria;
 */

    //// console.log('state', state)



    return {
        layerList: state.layer.layerList,
        layers: state.layer.layers,
        map: state.maps.map,
        // chapter: state.dossiers.chapter,
        lang: state.lang.lang,
        // admin: state.auth.admin,
        // editor: state.auth.editor
    }
}

export default withNamespaces()(connect(mapStateToProps, {
    fetchLayer,
    fetchLayers,
    fetchLayerList,
    fetchMap,
    updateMap,
    // fetchDossierChapters
})(Map));
